var map = {
	"./audit.json": 832,
	"./calendar.json": 324,
	"./cdr.json": 833,
	"./clients.json": 834,
	"./controlCard.json": 835,
	"./csv.json": 836,
	"./eqTypes.json": 837,
	"./equipments.json": 838,
	"./experiments.json": 839,
	"./laboratories.json": 840,
	"./locations.json": 841,
	"./lookup.json": 842,
	"./maintTypes.json": 843,
	"./materialTypes.json": 844,
	"./materials.json": 845,
	"./metadata.json": 846,
	"./orders.json": 847,
	"./projects.json": 848,
	"./queryTemplate.json": 849,
	"./reports.json": 850,
	"./samples.json": 851,
	"./signin.json": 852,
	"./signup.json": 853,
	"./specifications.json": 854,
	"./suppliers.json": 855,
	"./tasks.json": 856,
	"./testPlans.json": 857,
	"./tests.json": 858,
	"./translation.json": 859,
	"./uom.json": 860,
	"./validation.json": 861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 831;